import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CURRENCY_EDIT, CURRENCY_UPDATE } from "../../routes/routes";
import { toast } from "react-toastify";
import { CURRENCY_UPDATED } from "../../constant/constant";
import { ValidationMessage } from "../../components/Utils";

const EditCurrency = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios
      .get(CURRENCY_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setForm(res.data.data);
        }
      })
      .catch((err) => console.error(err));
  }, [id]);

  const submit = () => {
    setBtnDisabled(true);
    axios
      .put(CURRENCY_UPDATE + id, form)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(CURRENCY_UPDATED);
          navigate("/currency");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        } else {
          toast.error(err.response?.data?.msg || "Something went wrong");
        }
      })
      .finally(() => setBtnDisabled(false));
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Currency</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}><span>Dashboard</span></Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/currency"}><span>Currency List</span></Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Edit Currency</span></li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/currency"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="currency_name">
                          Currency Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="currency_name"
                          placeholder="e.g. Indian Rupee"
                          value={form?.currency_name || ""}
                          onChange={(e) => setForm({ ...form, currency_name: e.target.value, name: e.target.value })}
                        />
                        <ValidationMessage error={errors} name="currency_name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="currency_symbol">
                          Currency Symbol<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="currency_symbol"
                          placeholder="e.g. ₹"
                          value={form?.currency_symbol || ""}
                          onChange={(e) => setForm({ ...form, currency_symbol: e.target.value, symbol: e.target.value })}
                        />
                        <ValidationMessage error={errors} name="currency_symbol" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/currency"}>
                        <button type="button" className="btn btn-primary iclose_btn">
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={(e) => { e.preventDefault(); submit(); }}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCurrency;
